((scope) => {
  const EPSILON = 0.000001;
  const ladders = {
    1: [1, 2, 3], 2: [2, 3, 4], 3: [3, 4, 6], 4: [4, 6, 8],
    5: [5, 8, 10], 6: [6, 9, 12], 7: [7, 9, 12], 8: [8, 10, 12],
    9: [9, 12], 10: [10, 12], 11: [11, 12], 12: [12]
  };
  const classify = (schedule) => {
    const value = String(schedule || '').toLowerCase().trim().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');
    if (['daily', 'daily disposable', '1 day', 'one day'].includes(value)) return 'daily';
    if (['weekly', 'fortnightly', 'monthly', 'six monthly', 'six month', '6 monthly', '6 month', '2 weekly', 'two weekly'].includes(value)) return 'reusable';
    return 'unknown';
  };
  const wearBand = (supply, interval) => {
    const days = Math.min(7, 7 * supply / interval);
    if (days >= 6.5) return 'daily wear';
    if (days >= 5) return 'about 5–6 days per week';
    if (days >= 4) return 'about 4–5 days per week';
    if (days >= 3) return 'about 3–4 days per week';
    if (days >= 2) return 'about 2–3 days per week';
    return 'about 1–2 days per week';
  };
  const intersection = (variants, lines) => {
    const active = lines.filter((line) => Number(line.quantity) > 0);
    if (!active.length || active.some((line) => !variants[String(line.variantId)])) return [];
    const first = variants[String(active[0].variantId)].plans || [];
    return first.filter((plan) => Number.isInteger(plan.interval) && plan.interval >= 1 && plan.interval <= 12
      && active.every((line) => (variants[String(line.variantId)].plans || []).some((other) => String(other.id) === String(plan.id) && other.interval === plan.interval)))
      .filter((plan, index, plans) => plans.findIndex((other) => other.interval === plan.interval) === index)
      .sort((a, b) => a.interval - b.interval);
  };
  const choose = ({ plans, supply, manualId = '' }) => {
    const active = [[supply?.leftBoxes, supply?.leftMonths], [supply?.rightBoxes, supply?.rightMonths]]
      .filter(([boxes]) => Number(boxes) > 0);
    const empty = { options: [], selected: null, recommendation: 0, floor: 0, unequal: false, manualValid: false };
    if (!active.length || active.some(([, months]) => !Number.isFinite(Number(months)) || Number(months) <= 0)) return empty;
    const months = active.map(([, duration]) => Number(duration));
    const floor = Math.min(...months);
    const unequal = months.length > 1 && Math.abs(months[0] - months[1]) > EPSILON;
    const valid = plans.filter((plan) => plan.interval + EPSILON >= floor && plan.interval <= 12);
    const exact = !unequal ? valid.find((plan) => Math.abs(plan.interval - floor) <= EPSILON) : null;
    const desired = ladders[Math.ceil(floor - EPSILON)] || [];
    let options = valid.filter((plan) => desired.includes(plan.interval));
    if (!options.length && valid.length) options = [valid[0]];
    const manual = valid.find((plan) => String(plan.id) === String(manualId));
    if (manual && !options.some((plan) => String(plan.id) === String(manual.id))) {
      const retained = [exact, manual, ...options].filter(Boolean);
      options = retained.filter((plan, index) => retained.findIndex((other) => String(other.id) === String(plan.id)) === index).slice(0, 3);
    }
    options.sort((a, b) => a.interval - b.interval);
    return { options, selected: manual || exact || options[0] || null, recommendation: exact?.interval || 0, floor, unequal, manualValid: Boolean(manual) };
  };
  const api = { choose, classify, intersection, wearBand };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else scope.CityContactLensCadence = api;
})(typeof window !== 'undefined' ? window : globalThis);
